import { render, staticRenderFns } from "./ModalCustomer.vue?vue&type=template&id=2be2b669&"
import script from "./ModalCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports